<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando"> 
                <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false" @tableatualizada="tableatualizada( $event )" > 
                    <th>Inicio</th> 
                    <th style="max-width:100px">Id</th>
                    <th>Fim</th> 
                    <th>Nome</th> 
                    <th>Atualizado em</th> 
                    <th>Status</th> 
                    <th style="min-width:190px" class="text-center" v-if="hasPermissao">Ações</th> 
                    <template v-slot:filtros>   
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                            <div class="mb-2">
                                <label for="DataMin" class="form-label">Data</label>
                                <input  @keyup="apertouEnter" @blur="refreshTable"  type="date" data-kt-docs-table-filter="Data" class="form-control form-control-solid " placeholder="Data"/>
                            </div>
                        </div>  
                        <input type="text" data-kt-docs-table-filter="turmaId" v-model="turmaId" hidden/>   
                    </template>
                </KDataTable>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts"> 
    import { Options, Vue } from "vue-class-component";
    import { namespace } from 'vuex-class';
    const authStore = namespace('auth'); 
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue"   
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import QtsPdfService from '@/service/v1/sigap/QtsPdfService'; 
    import {  Prop , Watch  } from 'vue-property-decorator';   
	import $ from "jquery"    
    import Multiselect from '@vueform/multiselect'

    @Options({
        name: "QtsPdf",
        components: {  CardRh , KDataTable,   Multiselect},
    }) 
    export default class QtsPdf extends Vue {
          
        // @Prop( ) readonly turma!: any

        @authStore.Getter
        public perfis!: any 
        public turmaId: any = null;
        public dados: any = null;
        public modal_atualizar = 'modal_visualizar_qts_update_';   
        public modal_cadastro = 'kt_cadatrar_turma_qts_';
        public processando = false; 
        public reloadDatatable = false ;
        public config: any = null;  
        public service: any = new QtsPdfService();    
  
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE , PerfilConfig.Professor ] ,  this.perfis); 
        }
  
         
        public refreshTable(){ 
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable ; 
            }, 300); 
        }
         
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                this.refreshTable();
            }
        }
    
        created(){    
            this.turmaId = this.$route.params.turmaId;  
            this.config = {  ajax: {} , columns: [] , columnDefs: [] , order: [] };  
            this.config.ajax = { 
                url: this.service.getApiUrl()  ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length,  
                        "turmaId": () => (document.querySelector('[data-kt-docs-table-filter="turmaId"]')! as HTMLInputElement).value ,   
                        "data": () => (document.querySelector('[data-kt-docs-table-filter="Data"]')! as HTMLInputElement).value ,  
                        "search": d.search.value
                    }
                    return dados; 
                } 
            }; 
 
            this.config.columns = [  
                { data: "inicio", name: "inicio" , class:'desktop text-center'},   
                { data: "id", name: "id", class:'none' }, 
                { data: "fim", name: "fim" , class:'desktop text-center'},   
                { data: "nome", name: "nome" },   
                { data: "updatedAt", name: "updatedAt" , class:'desktop text-center'},   
                { data: "status.nome", name: "status.nome", class:'desktop text-center' },   
            ];
            
            this.config.columnDefs = [  
                {
                    targets: 0,
                    render: function ( row, type, val, meta ) {  
                        return SiteUtils.formatData( row )  ;
                    }
                }, 
                {
                    targets: 2,
                    render: function ( row, type, val, meta ) {  
                        return SiteUtils.formatData( row )  ;
                    }
                }, 
                {
                    targets: 3,
                    render: ( row, type, val, meta ) => {  
                        let texto = '' ; 
                        let buttom = '' ;  
                        for (var key in val) {  buttom = buttom + ' data-' + key + '="'+ val[key] +'"'  }  
                        texto = texto + '<button class="btn btn-secondary btn-sm" btn-link-href '+ buttom + ' title="Link">'+ row + '</i></button>';  
                        return texto;  
                    }, 
                }, 
                {
                    targets: 4,
                    render: function ( row, type, val, meta ) {  
                        return SiteUtils.formatDataHora( row )  ;
                    }
                }, 
            ]; 
            if(this.hasPermissao){
                this.config.columns.push({ data: 'id', name: 'id'  , orderable: false, searchable: false , class: 'text-center' });
                this.config.columnDefs.push( 
                    {
                        targets: 6,
                        render: ( row, type, val, meta ) => {  
                            let texto = '' ; 
                            let buttom = '' ;  
                            for (var key in val) {  buttom = buttom + ' data-' + key + '="'+ val[key] +'"'  }  
                            texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-link '+ buttom +' title="Link"><i class="fa fa-link"></i></button>';  
                            return texto;  
                        }, 
                    },  
                );   
            }
 
        }     
 
        public tableatualizada( event ) {  
            $('[btn-link]').click(  (btn) => {   
                let id =   $(btn.currentTarget).data('id');   
                this.getModelLink(id );  
            });  
            $('[btn-link-href]').click(  (btn) => {   
                let id =   $(btn.currentTarget).data('id');   
                this.getModelLink(id );  
            });  
        } 
         
        protected getModelLink( id  ) {  
           this.processando = true;  
            setTimeout(() => {
                this.service.getModelLink( id )
                .then(response => {    
                    this.processando = false;
                    window.open(response, "_blank" ) 
                })
                .catch(error => { 
                    this.processando = false;  
                });  
            }, 1); 
        }  
 
    } 
  
</script>